<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog v-model="Mostrar" :width="width" persistent :fullscreen="fullscreen" :hide-overlay="overlay">

      <vue-draggable-resizable :resizable="false" :draggable="dragable" :parent="false" class-name="my-class"
                               :style="'margin-left:' + margem_left +'%'" v-if="dragable" :drag-handle="'.headline'">
        <v-card>
          <v-card-title class="headline popup-header" primary-title id="modalhead"
                        style="background: black; color: white">
            {{getTitulo()}}
            <v-spacer></v-spacer>
            <v-tooltip left  v-if="dragable">
              <template v-slot:activator="{ on }">
                <v-checkbox small class="inp"  dark v-on="on" color="prmary" v-model="overlay" label=""></v-checkbox>
              </template>
              <span>Habilitar fundo</span>
            </v-tooltip>

          </v-card-title>
          <v-card-text>
            <v-contaier>
              <slot></slot>
            </v-contaier>
          </v-card-text>
        </v-card>
      </vue-draggable-resizable>


      <v-card v-else>
        <v-card-title class="headline" primary-title id="modalhead" :style="'background: '+setLoadingColor('black')+'; color: white'">
          {{getTitulo()}}
        </v-card-title>
        <v-card-text>
          <v-container>
            <slot></slot>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script async>
/* eslint-disable */
  import util from '../assets/js/Util'
import {mapGetters} from "vuex";

  export default {
    props: {
      titulo: {
        default: ''
      },
      modal: {
        default: false
      },
      fullscreen: {
        default: false
      },
      dragable: {
        default: false
      },
      width: {
        default: '50%'
      }
    },
    name: "ModalCadastro",

    data() {
      return {
        overlay: false,
        margem_left: '25',
        classe: '',
        util
      }
    },
    methods: {
      validarCampo(campo) {
        if (campo !== undefined && campo !== null && campo !== '') {
          return true
        } else {
          return false
        }
      },
      getTitulo() {
        if (util.validaCampo(this.titulo)) {
          return this.titulo
        } else {
          return this.$router.currentRoute.meta
        }
      },
      setLoadingColor(cor) {
        return this.validarCampo(this.tema) ? this.tema.cor : cor
      },
    },
    computed: {
      Mostrar: {
        get() {
          return this.modal
        },
        set() {
          return this.Mostrar
        }
      },
      ...mapGetters('configuracao', {tema: 'pegarTema'}),
    },
    watch: {
      modal: function () {
        if (this.modal) {
          var _this = this
          var inter = setInterval(function () {
            var mywidth = document.getElementById('drg')
            if (mywidth !== null) {
              var width = window.screen.width
              var w = mywidth.clientWidth
              var res = width - w
              res = res / 2
              res = (res * 100) / width
              _this.margem_left = parseInt(res)
            }
            clearInterval(inter)
          }, 500)
        }
      }
    }
  }
</script>

